import { j as e } from "../../../../_virtual/jsx-runtime.js";
import { groupKeysByStackId as M, calculateBarRadius as O } from "./utils.js";
import { COMMON_COLORS as i } from "../../../../constants/colors.js";
import $ from "./ChartLegend.js";
import D from "../../SkeletonWrapper/index.js";
import E from "../TooltipWrapper/index.js";
import { cn as u } from "../../../../lib/utils.js";
import H from "../MixedChart/YAxisTopLabel.js";
import { ResponsiveContainer as z } from "../../../../node_modules/recharts/es6/component/ResponsiveContainer.js";
import { ComposedChart as Y } from "../../../../node_modules/recharts/es6/chart/ComposedChart.js";
import { XAxis as x } from "../../../../node_modules/recharts/es6/cartesian/XAxis.js";
import { YAxis as _ } from "../../../../node_modules/recharts/es6/cartesian/YAxis.js";
import { Bar as f } from "../../../../node_modules/recharts/es6/cartesian/Bar.js";
import { Cell as U } from "../../../../node_modules/recharts/es6/component/Cell.js";
import { Line as V } from "../../../../node_modules/recharts/es6/cartesian/Line.js";
import { Tooltip as q } from "../../../../node_modules/recharts/es6/component/Tooltip.js";
const F = {
  top: 0,
  right: 0,
  left: 0,
  bottom: 0
}, de = ({
  data: a,
  config: o,
  legendDescription: j,
  height: y = 300,
  margin: n = F,
  barGap: l = 35,
  barSize: d = 12,
  tickXFontSize: m = 14,
  tickXColor: c = i.greyMid,
  xAxisDy: k = 12,
  xAxisBorderColor: b = i.greyLight,
  lineStrokeColor: C = i.teal500,
  lineDashArray: I = "5 5",
  lineStrokeWidth: g = 2,
  lineType: L = "monotone",
  showOccupancyTrend: v = !1,
  isLoading: K,
  leftAxis: t,
  displayTooltip: N = !1
}) => {
  const R = M(o), S = a.length * (d + l) + (n.left ?? 0) + (n.right ?? 0), W = ({ payload: r, label: s }) => {
    var h;
    const p = (h = r == null ? void 0 : r[0]) == null ? void 0 : h.payload;
    return p ? /* @__PURE__ */ e.jsxs(
      E,
      {
        className: u("-translate-y-[110%]"),
        children: [
          /* @__PURE__ */ e.jsx("span", { children: s }),
          o.map(
            ({ key: w, label: B, color: T }) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row gap-1", children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: u("flex self-center rounded-full h-2.5 w-2.5 mr-1"),
                  style: {
                    backgroundColor: T
                  }
                }
              ),
              /* @__PURE__ */ e.jsx("span", { children: `${B}: ${p[w]}` })
            ] })
          )
        ]
      }
    ) : null;
  };
  return /* @__PURE__ */ e.jsx(D, { isLoading: K, children: /* @__PURE__ */ e.jsxs("div", { style: { maxWidth: S }, children: [
    /* @__PURE__ */ e.jsx("div", { className: "relative", style: { height: y }, children: /* @__PURE__ */ e.jsx(z, { width: "100%", height: "100%", children: /* @__PURE__ */ e.jsxs(
      Y,
      {
        data: a,
        barSize: d,
        margin: n,
        barGap: l,
        children: [
          /* @__PURE__ */ e.jsx(
            x,
            {
              xAxisId: "bottom",
              orientation: "bottom",
              dataKey: "day",
              stroke: b,
              tick: { fontSize: m, fill: c },
              tickLine: !1,
              dy: k
            }
          ),
          /* @__PURE__ */ e.jsx(
            x,
            {
              xAxisId: "top",
              orientation: "top",
              dataKey: "total",
              stroke: "transparent",
              tick: { fontSize: m, fill: c },
              tickLine: !1
            }
          ),
          t && /* @__PURE__ */ e.jsx(
            _,
            {
              stroke: "#888888",
              fontSize: 12,
              includeHidden: !0,
              label: {
                value: t == null ? void 0 : t.label,
                content: ({ viewBox: r }) => /* @__PURE__ */ e.jsx(
                  H,
                  {
                    label: t == null ? void 0 : t.label,
                    icon: t == null ? void 0 : t.labelIcon,
                    position: "left",
                    viewBox: r
                  }
                )
              },
              ...t
            }
          ),
          o.map((r) => /* @__PURE__ */ e.jsx(
            f,
            {
              xAxisId: "bottom",
              dataKey: r.key,
              stackId: r.stackId,
              fill: r.color,
              children: a.map((s) => /* @__PURE__ */ e.jsx(
                U,
                {
                  radius: O(
                    s,
                    r.key,
                    R[r.stackId]
                  )
                },
                `${s.day}-${r.key}`
              ))
            },
            r.key
          )),
          /* @__PURE__ */ e.jsx(f, { xAxisId: "bottom", dataKey: "barHeightReference", barSize: 0 }),
          v && /* @__PURE__ */ e.jsx(
            V,
            {
              xAxisId: "top",
              type: L,
              dataKey: "total",
              stroke: C,
              strokeDasharray: I,
              strokeWidth: g,
              dot: !1
            }
          ),
          N && /* @__PURE__ */ e.jsx(
            q,
            {
              content: W,
              allowEscapeViewBox: { x: !0, y: !0 },
              offset: 0,
              isAnimationActive: !1,
              cursor: !0,
              includeHidden: !0
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ e.jsx($, { ledengDescription: j, config: o })
  ] }) });
};
export {
  de as default
};
